import { toast } from "react-toastify";

export const ToastyGreen = (content: string) => toast.success(content);
